export default __webpack_public_path__ + "static/media/flag-north-korea.b35db9a7.svg";